/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const Horoscope: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => {
  return <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.9996 7.46484C18.3376 9.12687 17.4039 11.3811 17.4039 13.7315C17.4039 16.082 18.3376 18.3362 19.9996 19.9982C21.6617 21.6602 23.9159 22.5939 26.2663 22.5939C28.6168 22.5939 30.871 21.6602 32.533 19.9982C32.533 22.477 31.7979 24.9002 30.4207 26.9613C29.0436 29.0224 27.0861 30.6288 24.7959 31.5775C22.5058 32.5261 19.9857 32.7743 17.5545 32.2907C15.1233 31.8071 12.8901 30.6134 11.1372 28.8606C9.38442 27.1078 8.19074 24.8745 7.70714 22.4433C7.22354 20.0121 7.47174 17.492 8.42036 15.2019C9.36898 12.9117 10.9754 10.9543 13.0365 9.57709C15.0976 8.19991 17.5208 7.46484 19.9996 7.46484Z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.5508 8.22656L27.6557 11.7628H31.2313L28.3386 13.9484L29.4435 17.4846L26.5508 15.2991L23.6581 17.4846L24.763 13.9484L21.8703 11.7628H25.4459L26.5508 8.22656Z"
      stroke={color}
      strokeWidth="1.6"
    />
  </svg>
}
